import React, { PureComponent } from "react";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import { getStubGroupList, getCityList } from "../../../fetch/fetchApi";
import RefreshGrid from "../../../utils/refreshGrid";

// eslint-disable-next-line arrow-parens
@connect((state) => state)
class StubGroupList extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    // 设置电站id
    this.queryStubGroupName = "";
    this.queryStubGroupId = "";
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.queryStubGroupName = window.LayoutTab.tabParam.stubGroupName
        ? window.LayoutTab.tabParam.stubGroupName
        : "";
      this.queryStubGroupId = window.LayoutTab.tabParam.stubGroupId
        ? window.LayoutTab.tabParam.stubGroupId
        : "";
    }
    this.state = {
      visible: false,
      internationalization: this.props.intl.messages.stubGroupList,
      typeOption: [
        {
          text: this.props.intl.messages.stubGroupList.all, // '全部',
          value: "",
        },
      ],
    };
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.setState({
      formConfig: this.initFormConfig(),
    });
    this.init();
  }

  componentDidMount() {
    this.fetchApi({});
  }

  initFormConfig = () => {
    const formConfig = {
      childItems: [
        {
          type: "areaPicker",
          isPickArea: !0,
          placeholder: this.state.internationalization.placeholder1, // '请选择地区',
          mapKey: {
            label: "label",
            value: "value",
            children: "children",
          },
          pickOnSelect: true,
          param: {
            name: "cityId", // 与form表单绑定的参数名
            type: "array",
          },
          // defaultValue: ['34'], //默认值
          required: !1,
          labelName: this.state.internationalization.title1, // '地区',
          className: "allshow",
          sourceApi: getCityList,
        },
        {
          type: "input",
          placeholder: this.state.internationalization.title2, // '电站名称',
          param: {
            name: "stubGroupName",
            type: "string",
          },
          labelName: this.state.internationalization.title2, // '电站名称:',
          required: false,
          defaultValue: this.queryStubGroupName ? this.queryStubGroupName : "",
        },
        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "submit",
              // icon:'search',
              text: this.state.internationalization.btn1, // '查询'
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      defaultParams: {
        stubGroupName: this.queryStubGroupName ? this.queryStubGroupName : "",
      },
      tableKey: "stubGroupListTable",
    };
    return formConfig;
  };

  init() {
    this.setState({
      tableConfig: {
        tableKey: "stubGroupListTable",
        tableColumns: [
          {
            name: this.state.internationalization.title2, // '电站名称',
            key: "name",
            colType: "textCol",
            render: (value) => {
              if (value.length > 20) {
                return <span title={value}>{value}</span>;
              } else if (value) {
                return value;
              } else {
                return "--";
              }
            },
          },
          {
            name: `${this.state.internationalization.title3}(枪)`, // '直流数',
            key: "dcSubCnt",
            colType: "textCol",
            align: "center",
            width: 250,
          },
          {
            name: `${this.state.internationalization.title4}(枪)`, // '交流数',
            key: "acStubCnt",
            colType: "textCol",
            align: "center",
            width: 250,
          },
          {
            name: "上线日期", // '电站地区',
            key: "startTime",
            colType: "textCol",
            align: "left",
          },
          {
            name: this.state.internationalization.title5, // '电站地区',
            key: "cityName",
            colType: "textCol",
            align: "left",
            width: 250,
          },
          {
            name: "详细地址", // '电站地区',
            key: "address",
            colType: "tipCol",
            align: "left",
            tipNum: 15,
          },
          {
            name: this.state.internationalization.action, // '操作',
            key: "action",
            fix: "right",
            width: 250,
            colType: "action",
            actionMap: [
              {
                type: "href",
                actionName: this.state.internationalization.btn2, // '设备列表',
                handler: (record) => {
                  // localStorage.stubGroupId = record.key;
                  // localStorage.stubGroupName = record.name;
                  this.openTab(
                    {
                      // keyId: `stub_${record.key}`,
                      StubName: record.name,
                      stubGroupId: record.key,
                    },
                    {
                      key: "0102",
                      titleText: this.state.internationalization.btn3, // '设备快速查询',
                    },
                  );
                },
              },
              {
                type: "href",
                actionName: this.state.internationalization.btn4, // '配电柜列表',
                handler: (record) => {
                  // localStorage.stubGroupName = record.name;
                  // localStorage.stubGroupId = record.key;
                  this.openTab(
                    {
                      stubGroupName: record.name,
                      stubGroupId: record.key,
                    },
                    {
                      key: "0104",
                      titleText: this.state.internationalization.btn5, // '配电柜管理'
                    },
                  );
                },
              },
              // {
              //   type:"href",
              //   actionName:"诊断报告",
              //   handler:(record) => {
              //     this.props.onAdd(
              //       {
              //           key: "10zdbg",
              //           titleText: "诊断报告", // '配电柜管理'
              //       },{
              //           stubGroupName:record.name,
              //           stubGroupId:record.key,
              //       }
              //     )
              //     // this.openTab({
              //     //   stubGroupName:record.name,
              //     //   stubGroupId:record.key,
              //     // }, {
              //     //   key: "10zdbg",
              //     //   titleText: "诊断报告", // '配电柜管理'
              //     // });
              //   }
              // },
              {
                type: "href",
                actionName: "电站拓扑图", // '配电柜列表',
                handler: (record) => {
                  // localStorage.stubGroupName = record.name;
                  // localStorage.stubGroupId = record.key;
                  this.openTab(
                    {
                      stubGroupName: record.name,
                      stubGroupId: record.key,
                    },
                    {
                      key: "stubGroupTobu",
                      titleText: "电站拓扑图", // '配电柜管理'
                    },
                  );
                },
              },
            ],
          },
        ],
        tableChange: () => {},
        tableParam: {
          pagecount: 10,
          stubGroupName: this.queryStubGroupName ? this.queryStubGroupName : "",
        },
        dataApi: getStubGroupList,
        autoRefresh: !0, // 设置为true 直接加载grid数据
      },
    });
  }

  fetchApi = (param) => {
    console.log(1);
    const newParam = param;
    const selectCity = (param.cityId && param.cityId.split(",")) || [];
    this.queryStubGroupName = "";
    this.init();
    switch (selectCity.length) {
      case 1:
        newParam.cityId = selectCity[0];
        break;
      case 2:
        newParam.cityId = selectCity[1];
        break;
      case 3:
        newParam.cityId = selectCity[2];
        break;
      default:
        newParam.cityId = "";
        break;
    }

    console.log(newParam);

    console.log(this);

    // 当设置formTarget为grid时，执行自定义提交事件。
    if (this.state.formConfig.formTarget === "grid") {
      console.log(123);
      return;
    }
    // 请求fetch 对象，带入生成参数
    // 如果在modal中的表单提交，请执行这里
    if (this.props.modalSubmit) {
      console.log(1234);
      return this.props.modalSubmit(param);
    } else {
      console.log(1235);
      // 如果正常页面中的表单提交，请执行下面
      return RefreshGrid(this.context.store, "stubGroupListTable", newParam);
    }
  };

  openTab(param, e) {
    this.props.onAdd.bind(window.LayoutTab)(e, param);
  }

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel">
          <ScGridTable config={this.state.tableConfig} />
        </div>
      </div>
    );

    return Content;
  }
}

export default injectIntl(StubGroupList);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stubGroup/stubGroupList.js